// Single region constraint - Taiwan only
export const DEFAULT_COUNTRY_CODE = 'tw';
export const VALID_COUNTRY_CODES = new Set(['tw']);
